<template>
    <div class="grid grid-cols-1 gap-4">
        <FormInput
            v-model="form.full_name"
            name="full_name"
            test-id="contact-name"
            autocomplete="name"
            @change="validateInput('full_name')"
            :validating="isValidating"
            :valid="valid.full_name"
            :label="translations.fields.contact_name"
            :error-message="form.errors.full_name" />
        <FormInput
            v-model="form.company_name"
            name="company_name"
            test-id="contact-company"
            autocomplete="organization"
            @change="validateInput('company_name')"
            :validating="isValidating"
            :valid="valid.company_name"
            :label="translations.fields.contact_company"
            :error-message="form.errors.company_name" />
        <FormInput
            v-model="form.email"
            name="email"
            type="text"
            test-id="contact-email"
            inputmode="email"
            autocomplete="email"
            @change="validateInput('email')"
            :validating="isValidating"
            :valid="valid.email"
            :label="translations.fields.contact_email"
            :error-message="form.errors.email" />
        <FormPhone
            v-model:phoneCountry="form.phone_country"
            v-model:phone="form.phone"
            @change="validateInput('phone')"
            :validating="isValidating"
            :valid="valid.phone"
            :phone-label="translations.fields.contact_phone"
            :phone-country-label="translations.fields.country"
            :errorMessage="form.errors.phone" />
    </div>
</template>

<script
    setup
    lang="ts"
    generic="
        T extends {
            full_name: string | null;
            company_name: string | null;
            email: string | null;
            phone: string | null;
            phone_country: string | null;
        }
    ">
import type { InertiaFormProps, PrecognitionFormProps } from "@internal-types/inertia-form";
import { computed } from "vue";

defineProps<{ translations: Domain.UI.Components.Shared.LeadFormFields }>();

const form = defineModel<PrecognitionFormProps<T> | InertiaFormProps<T>>({ required: true });

const isValidating = computed(() => {
    if ("valid" in form.value) return form.value.validating;
    return false;
});

const validateInput = (key: keyof T) => {
    if ("valid" in form.value) form.value.validate(String(key));
};

const valid = computed(() => {
    if ("valid" in form.value) {
        return {
            full_name: form.value.valid && form.value.valid("full_name") && !!form.value.full_name,
            email: form.value.valid && form.value.valid("email") && !!form.value.email,
            phone: form.value.valid && form.value.valid("phone") && !!form.value.phone,
            company_name: form.value.valid && form.value.valid("company_name") && !!form.value.company_name,
        };
    }
    return {
        full_name: null,
        email: null,
        phone: null,
    };
});
</script>
